import {css} from 'lit';
export const styles = css`:host {
  display: flex;
}

slot[name='avatar'] {
  --avatar-size: 55px;

  display: block;
  margin-right: 16px;
}

.info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 auto;
}

.publisher {
  --link-text: var(--dark-text);

  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: var(--bu-font-size-base);
}

.publisher ef-icon[name='shield-check'] {
    margin-left: 4px;
    color: var(--primary);
    font-size: 1.1em;
  }

.breadcrumbs {
  --link-text: var(--text-secondary);
  --text-primary: var(--text-secondary);
  --icon-color-primary: var(--text-secondary);
  --icon-font-size-primary: var(--bu-font-size-sm);

  font-size: var(--bu-font-size-sm);
  word-break: break-all;
  margin-top: 2px;
  margin-bottom: 2px;
}

ef-timeago {
  font-size: var(--bu-font-size-xs);
}

:host:last-child .info {
  padding-bottom: 0;
  border-bottom: none;
}

::slotted([slot='breadcrumbs']:not(:last-child))::after {
  content: '>';
  color: var(--dark-text);
  margin-left: 4px;
  margin-right: 4px;
}
`;
export default styles;
